import { Chip, Stack, Tooltip, IconButton } from '@mui/material';
import UsbIcon from '@mui/icons-material/Usb';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { useSensorConnection } from '../../../contexts/SensorConnectionProvider';

// Global indicator: shows a live sensor session on every dashboard page and
// lets the user drop it from anywhere. Renders nothing while disconnected.
export default function SensorConnectionBadge() {
  const { connected, deviceInfo, disconnect } = useSensorConnection();

  if (!connected) return null;

  const label = deviceInfo?.model ? `Sensor: ${deviceInfo.model}` : 'Sensor connected';

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Chip
        icon={<UsbIcon />}
        label={label}
        color="success"
        variant="outlined"
        size="small"
      />
      <Tooltip title="Disconnect sensor">
        <IconButton size="small" aria-label="Disconnect sensor" onClick={() => disconnect()}>
          <LinkOffIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
